import React from 'react';

import { Modal } from '../';
import Upload from './Upload';

interface ComponentProps {
  isOpen: boolean;
  onClose: () => void;
  useUploadMutation: () => [any, any];
  header?: string;
  label?: string;
  requirements?: string[];
}

const UploadModal: React.FC<ComponentProps> = ({ isOpen, onClose, useUploadMutation, header, label, requirements }) => {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={(toggle) => (toggle ? undefined : onClose())}
      header={<span>{header}</span>}
      headerClassName="header"
      size="xl"
    >
      <Upload label={label} requirements={requirements} useUploadMutation={useUploadMutation} isOpen={isOpen} />
    </Modal>
  );
};

export default UploadModal;
